export default __webpack_public_path__ + "static/media/list.f8a05910.svg";